import styled from 'styled-components'

export const Footer = styled.footer`
  padding: 2rem 1.5rem;
  background-color: #fafafa;
`

export const FooterContent = styled.div`
  max-width: 800px;
  margin: auto;
`



// WEBPACK FOOTER //
// ./src/components/templates/login/Footer.js